import React, { Component, Fragment } from 'react';
import Rest from "../../services/Rest";
import {Link, withRouter} from "react-router-dom";
import Sidebar from '../navigation/Sidebar';

const initialState = {
    log: [],
    usuario_nombre: "",
    saldo_usuario: 0,
    total_mensajes_campana: 0,
    costo_total_mensajes: 0,
    saldo_usuario_restante: 0,
    error: false,
    messageError: "",
    success: false,
    messageSuccess: "",
    busqueda: ""
}

class Log extends Component {
    constructor(props) {
        super(props)
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
        this.state = { ...initialState }
    }
    componentDidMount() {
        this.Rest.get('log/' + this.props.match.params.id, this.datauser)
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({
                        log: resp.data.log,
                        usuario_nombre: resp.data.usuario_nombre,
                        saldo_usuario: resp.data.saldo_usuario,
                        total_mensajes_campana: resp.data.total_mensajes_campana,
                        costo_total_mensajes: resp.data.costo_total_mensajes,
                        saldo_usuario_restante: resp.data.saldo_usuario_restante
                    })
                }
                else {
                    if (resp.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: resp.message
                        })
                    }
                }
            })
            .catch(err => {

            })
    }


    buscar(event) {
        this.setState({
            busqueda: event.target.value.substr(0, 20)
        })
    }

    limpiar() {
        this.setState({
            busqueda: ""
        })
    }


    render() {
        const { usuario_nombre,
            total_mensajes_campana,
            costo_total_mensajes,
            saldo_usuario_restante } = this.state;

        let log = this.state.log.filter(
            (lg) => {
                return lg.numero.indexOf(this.state.busqueda) !== -1
            }
        )

        return (
            <Fragment>
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Registro de mensajes enviados de campaña</h4>
                                        <div className="d-flex">
                                            <div>
                                                <ul className="list-inline">
                                                    <li className="list-inline-item">
                                                        Buscar un número:
                    </li>
                                                    <li className="list-inline-item">
                                                        <input type="search" name="buscarnumero" id="buscarnumero" className="form-control"
                                                            onChange={this.buscar.bind(this)}
                                                            value={this.state.busqueda} />
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-secondary" type="button"
                                                            onClick={() => this.limpiar()}>Limpiar</button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="ml-auto">
                                                <div className="ml-auto">
                                                    <div className="c-card mb-5">
                                                        <h5>Usuario: {usuario_nombre}</h5>
                                                        <div className="list-inline">
                                                            <div className="list-inline-item">

                                                                <div className="c">
                                                                    <div className="c-header">Mensajes</div>
                                                                    <div className="c-body">
                                                                        <span>
                                                                            {total_mensajes_campana}
                                                                        </span>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                            <div className="list-inline-item">

                                                                <div className="c">
                                                                    <div className="c-header">Costo total</div>
                                                                    <div className="c-body">
                                                                        <span>
                                                                            ${costo_total_mensajes}
                                                                        </span>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                            <div className="list-inline-item">


                                                                <div className="c">
                                                                    <div className="c-header">Crédito</div>
                                                                    <div className="c-body">

                                                                        {saldo_usuario_restante < 0 ? <span className="text-danger">${saldo_usuario_restante}</span> : <span>${saldo_usuario_restante}</span>}

                                                                    </div>
                                                                </div>


                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>



                                        <div className="table-responsive">
                                            <table className="table table-sm table-striped table-condensed table-bordered">
                                                <thead>
                                                    <tr>

                                                        <th>Fecha de envío</th>
                                                        <th>Estado del mensaje</th>
                                                        <th>Mensaje</th>
                                                        <th>Número</th>
                                                        <th>Campaña</th>
                                                        <th>Costo</th>
                                                        <th>Servidor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {log.length > 0 ?
                                                        log.map((val, index) => (
                                                            <tr key={index}>

                                                                <td>
                                                                    {val.timestamp_creacion}
                                                                </td>
                                                                <td align="center">
                                                                    {val.estatus === "1" ? <span className="badge badge-pill badge-success">Enviado</span> : <span className="badge badge-pill badge-secondary">Sin enviar</span>}
                                                                </td>
                                                                <td>
                                                                    {val.mensaje}
                                                                </td>
                                                                <td>
                                                                    {val.numero}
                                                                </td>
                                                                <td>
                                                                    {val.nombre_campana}
                                                                </td>
                                                                <td>
                                                                    ${val.costo}
                                                                </td>
                                                                <td>
                                                                    {val.nombre_servidor !== null ? val.nombre_servidor : "NA"}
                                                                </td>
                                                            </tr>
                                                        ))
                                                        :
                                                        <tr>
                                                            <td colSpan="7">
                                                                <div className="alert alert-warning">Esta campaña no cuenta con registro de mensajes</div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="container">
                                            <Link to="/lista-de-campañas" className="btn btn-secondary ml-3">&laquo; Volver</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(Log);


// WEBPACK FOOTER //
// ./src/components/campaigns/Log.js